<template>
  <div class="wt2-full-preview">
    <!-- <template v-if="showFirstPage"> -->
    <preview-maker
      :story="story"
      ref="previewMaker"
      :closeModal="closeModal"
      :showGeneratedLink="showGeneratedLink"
      :previewVideoUrl="previewVideoUrl"
      :fullPreviewJob="fullPreviewJob"
      :valid.sync="previewMakerOk"
      :screenshot.sync="screenshot"
    />
    <div class="-checkbox-group" v-if="isStoryboarder">
      <span class="-label">{{ 'storyboards.publish' | culture }}:</span>
      <span v-tooltip="shortcutTooltip">
        <wt-check-box
          @changed="publish.shortcut = $event"
          :checked="publish.shortcut"
          :label-right="'storyboards.shortcut' | culture"
          :disabled="timelineHasAudio"
        />
      </span>
      <span v-tooltip="massProduceTooltip">
        <wt-check-box
          @changed="publish.massProduce = $event"
          :checked="publish.massProduce"
          :label-right="'storyboards.massProduce' | culture"
        />
      </span>
    </div>
    <div class="-full-preview-footer">
      <share-page-dropdown
        v-if="!isEmbedded"
        :story="story"
        :showGeneratedLink="showGeneratedLink"
        :previewVideoUrl="previewVideoUrl"
        @pause-playing="onPausePlaying"
        :style="{ visibility: previewMakerOk ? 'visible' : 'hidden' }"
      />

      <div class="-spring" />

      <div class="-actions" v-tab-guard>
        <wt-button
          type="transparent"
          class="-min-width-unset"
          tabindex="0"
          :text="'fullPreview.CANCEL_BUTTON' | culture"
          @click="closeModal"
        />
        <wt-button
          type="primary"
          tabindex="-1"
          :disabled="!canProduce"
          :text="'fullPreview.PRODUCE_TEMPLATE_BUTTON' | culture"
          @click="produceStoryboard"
        />
        <!-- <wt-button
            type="primary"
            tabindex="-1"
            :disabled="!previewMakerOk"
            :text="'fullPreview.GOFROM_PREVIEW' | culture"
            @click="nextPage"
          /> -->
      </div>
    </div>
    <!-- </template>
    <template v-else>
      <wt-close class="-close" @click.native="closeModal"/>
      <i class="-backto wticon wticon-angle-left"
        :title="'fullPreview.BACKTO_PREVIEW' | culture"
        @click="prevPage"
      />

      <category-chooser
        ref="categoryChooser"
        :allCategories="allCategories"
        :valid.sync="categoryChooserOk"
        :storyTitle.sync="storyTitle"
        :categorySelectionState.sync="categorySelectionState"
      />

      <div class="-full-preview-footer">
        <share-page-dropdown
          :story="story"
          :showGeneratedLink="showGeneratedLink"
          :style="{visibility: previewMakerOk?'visible':'hidden'}"
        />

        <div class="-actions" v-tab-guard>
          <wt-button
            type="transparent"
            class="-min-width-unset"
            tabindex="0"
            :text="'fullPreview.CANCEL_BUTTON' | culture"
            @click="closeModal"
          />
          <wt-button
            type="primary"
            tabindex="-1"
            :disabled="!canProduce"
            :text="'fullPreview.PRODUCE_TEMPLATE_BUTTON' | culture"
            @click="produceStoryboard"
          />
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
import app from 'app';
import PreviewMaker from './PreviewMaker.vue';
import SharePageDropdown from './sharePageDropdown.vue';
import { mapState } from 'vuex';
// import CategoryChooser from './CategoryChooser.vue';

export default {
  name: 'storyboard-full-preview',

  components: {
    PreviewMaker,
    SharePageDropdown,
    // CategoryChooser,
  },

  props: {
    story: { type: Object, required: true },
    closeModal: { type: Function, required: true },
    isStoryboarder: { type: Boolean, required: true },
  },

  data() {
    // const allCategories = _.filter(this.$store.getters.allStoryboardCategories, (c) => !c._abstractCategory);
    // const selectedCategories = {};
    // const storySelectedCategories = this.story.get('_categories');
    // _.each(allCategories, (category) => {
    //   selectedCategories[category.id] = _.includes(storySelectedCategories, category.id);
    // });

    return {
      screenshot: { image: null, time: null },
      // allCategories,
      // categorySelectionState: selectedCategories,
      storyTitle: this.story.get('title'),
      previewVideoUrl: '',
      fullPreviewJob: null,
      // showFirstPage: true,
      showGeneratedLink: false,
      previewMakerOk: false,
      // categoryChooserOk: false,
      publish: {
        shortcut: true,
        massProduce: true,
      },
      isEmbedded: app.isEmbedded,
    };
  },

  computed: {
    ...mapState({
      lightboxUploadingVoiceOverAssets: (state) =>
        state.story.lightboxUploadingVoiceOverAssets,
      audioTracks: (state) => state.story.audioTracks,
    }),

    timelineHasAudio() {
      return !_.isEmpty(this.audioTracks);
    },

    canProduce() {
      return this.previewMakerOk; // && this.categoryChooserOk;
    },

    selectedCategoryIds() {
      // object of {id: boolean, ...} to Array<String> of id's which had true ["id", ...]
      return _.filter(
        _.map(this.categorySelectionState, (v, key) => (v ? key : null))
      );
    },

    publishCommonTooltip() {
      return {
        animation: false,
        trigger: 'hover',
        container: '.wt2-full-preview',
        placement: 'top',
        delay: { show: 250, hide: 0 },
      };
    },

    shortcutTooltip() {
      const title = this.timelineHasAudio
        ? app.culture.get('storyboards.shortcutWithoutAudio')
        : app.culture.get('storyboards.shortcutExplain');
      return {
        ...this.publishCommonTooltip,
        title,
      };
    },

    massProduceTooltip() {
      return {
        ...this.publishCommonTooltip,
        title: app.culture.get('storyboards.massProduceExplain'),
      };
    },
  },

  beforeDestroy() {
    if (this.fullPreviewJob) {
      this.fullPreviewJob.stopListening();
    }
  },

  created() {
    this.previewVideoUrl = this.story.get('_previewVideoUrl') || '';
    this.fullPreviewJob = app.api.fullPreview.checkout(
      this.story,
      this.previewVideoUrl
    );

    this.fullPreviewJob.execution.done(() => {
      this.showGeneratedLink = true;
    });
    this.fullPreviewJob.on('change:cdnUrl', (job, value) => {
      this.fullPreviewJob.off('change:cdnUrl');
      this.previewVideoUrl = value;
    });
    this.publish = {
      shortcut: this.story.get('_shortcutEnabled'),
      massProduce: this.story.get('_massProduceEnabled'),
    };

    if (this.publish.shortcut && this.timelineHasAudio) {
      this.publish.shortcut = false;
      this.story.set('_shortcutEnabled', false);

      app.api.draftStoryTemplates.updateTemplateMetadata({
        storyId: this.story.get('id'),
        categoryIds: this.story.get('_categoryIds'),
        lockBgMusic: this.story.get('_lockBgMusic'),
        channelId: app.rootStore.state.user.channelId,
        shortcutEnabled: false,
      });
    }
  },

  methods: {
    produceStoryboard() {
      if (!this.canProduce) {
        return;
      }

      app.api.fullPreview.remove();

      app.api.draftStoryTemplates
        .updateTemplateMetadata({
          storyId: this.story.get('id'),
          categoryIds: this.story.get('_categoryIds'),
          channelId: app.rootStore.state.user.channelId,
          lockBgMusic: this.story.get('_lockBgMusic'),
          ...Object.entries(this.publish).reduce(
            (obj, arr) => ({ ...obj, [arr[0] + 'Enabled']: arr[1] }),
            {}
          ),
        })
        .then(
          () => {
            this.closeModal({
              produce: true,
              snapshotTime: this.screenshot.time,
            });
          },
          (error) => {
            app.doctorController.report(
              `Failed to update categories during produce Storyboard: ${JSON.stringify(
                error
              )}`
            );
          }
        );
    },

    onPausePlaying() {
      this.$refs.previewMaker && this.$refs.previewMaker.onPausePlaying();
    },

    // nextPage() {
    //   this.showFirstPage = false;
    // },

    // prevPage() {
    //   this.showFirstPage = true;
    // },
  },
};
</script>

<style lang="scss" scoped>
.wt2-full-preview /deep/ .tooltip-arrow {
  border-top-color: #fff !important;
}
.-checkbox-group {
  padding-left: 20px;
  height: 51px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  > span {
    padding-right: 30px;
    /deep/ .-label-right {
      max-width: 100%;
    }
  }
}
</style>
